import { IconButton } from '@mui/material'
import React from 'react'
import RemoveIcon from '@mui/icons-material/Remove'
import AddIcon from '@mui/icons-material/Add'

export default function ExtendedIconButton({ isExpanded, onClick }) {
	return (
		<IconButton
			size='small'
			onClick={onClick}
			sx={{
				p: 0,
				color: 'primary.main',
			}}>
			{isExpanded ? <RemoveIcon /> : <AddIcon />}
		</IconButton>
	)
}

